//# sourceMappingURL=content-definition.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/content-definition.interface.js
// module id = 1164
// module chunks = 4